import { render, staticRenderFns } from "./FoodDataList.vue?vue&type=template&id=fe50f964&scoped=true"
import script from "./FoodDataList.vue?vue&type=script&lang=js"
export * from "./FoodDataList.vue?vue&type=script&lang=js"
import style0 from "./FoodDataList.vue?vue&type=style&index=0&id=fe50f964&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fe50f964",
  null
  
)

export default component.exports